


// JS for the loading animation and slider on collection page
    $('.custom-collection__List .shop_by_category').hide();
    $('.custom-collection__List .title-wrapper-with-link').hide();
    $('.custom-collection__List .swiper-button-next').hide();
    $('.custom-collection__List .swiper-button-prev').hide();

    
$(window).on('load resize', function() {
  var swipercl = null;
  var loadingOverlay = $(".loading-overlay-collection");  // Assumes there's a div with class 'loading-overlay' for the spinner.

  // Function to initialize the swiper and fade out the loading animation
  function initSwipercl() {
    // Initially, hide the navigation and content


    swipercl = new Swiper(".custom-collection__List .shop_by_category", {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      spaceBetween: 0,
      speed: 1000,
      loop: false,
      freeMode: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // On initialization, handle showing the slider and fading out the loading animation
      on: {
        init: function() {
          // Fade out the loading overlay and fade in the slider
          loadingOverlay.fadeOut(500, function() {
            document.querySelector('.custom-collection__List .shop_by_category').style.display = "block";
            document.querySelector('.custom-collection__List .title-wrapper-with-link').style.display = "block";
            // $('.custom-collection__List .swiper-button-next').fadeIn(500);
            // $('.custom-collection__List .swiper-button-prev').fadeIn(500);
          });
        },
      },
    });
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwipercl, 200);
  });

  if ($('.custom-collection__List .shop_by_category .swiper-button-next').hasClass('swiper-button-disabled')) {
    // Allow the next button to be active once swiper initializes
    $('.custom-collection__List .shop_by_category .swiper-button-next').removeClass('swiper-button-disabled swiper-button-lock');
  }

  // Initialize Swiper and set up everything
  initSwipercl();
});


